// src/components/Shared/LoginModal.jsx
import React from 'react'
import PropTypes from 'prop-types'
import { Modal, Tabs } from 'antd'
import Login from '../../pages/platform/Users/Login'
import { observer } from 'mobx-react-lite'
import ResetPassword from '../../pages/platform/Users/ResetPassword'
import Register from '../../pages/platform/Users/Register'
import { useSmartTranslation } from '../../cls/TranslationContext'

const LoginModal = ({ title, open, onClose, onLoggedIn, modalProps }) => {
	const { t } = useSmartTranslation()
	const handleLoggedIn = (...args) => {
		onLoggedIn?.(...args)
		onClose?.()
	}
	return (
		<Modal
			width={900}
			open={open}
			footer={null}
			onCancel={onClose}
			destroyOnClose
			{...modalProps}
		>
			{title && <h2>{title}</h2>}
			<Tabs
				defaultActiveKey="1"
				items={[
					{
						key: '1',
						label: t('single.login.label'),
						children: (
							<Login actionOnLogin={handleLoggedIn} hideRelated />
						)
					},
					{
						key: '2',
						label: t('single.signup.label'),
						children: (
							<Register
								actionOnLogin={handleLoggedIn}
								hideRelated
							/>
						)
					},
					{
						key: '3',
						label: t('single.password.reset'),
						children: (
							<ResetPassword
								actionOnLogin={handleLoggedIn}
								hideRelated
							/>
						)
					}
				]}
			/>
		</Modal>
	)
}

LoginModal.propTypes = {
	title: PropTypes.string,
	open: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	onLoggedIn: PropTypes.func,
	modalProps: PropTypes.object
}

export default observer(LoginModal)
